import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Track } from 'livekit-client';

/**
 * Anexa/desanexa um Track LiveKit a um <video> ou <audio>.
 */
@Directive({
    selector: '[livekitTrack]',
    standalone: true,
})
export class LivekitTrackDirective implements OnChanges, OnDestroy {
    @Input('livekitTrack') track: Track | null = null;
    @Input() livekitMuted = false;

    private attached: Track | null = null;

    constructor(private readonly el: ElementRef<HTMLMediaElement>) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['track'] || changes['livekitMuted']) {
            this.sync();
        }
    }

    ngOnDestroy(): void {
        this.detach();
    }

    private sync(): void {
        const media = this.el.nativeElement;
        if (this.attached && this.attached !== this.track) {
            this.detach();
        }
        if (this.track && this.attached !== this.track) {
            this.track.attach(media);
            this.attached = this.track;
        }
        media.muted = this.livekitMuted;
        if (media instanceof HTMLVideoElement) {
            media.playsInline = true;
            media.autoplay = true;
            media.removeAttribute('width');
            media.removeAttribute('height');
        }
        if (media instanceof HTMLAudioElement) {
            media.autoplay = true;
        }
    }

    private detach(): void {
        if (this.attached) {
            this.attached.detach(this.el.nativeElement);
            this.attached = null;
        }
    }
}
